import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet } from 'react-native';
import QText from './QText';

const DividerText = ({ text }) => {
  return (
    <View style={styles.dividerContainer}>
      <View style={styles.line} />
      <View>
        <QText style={styles.text}>{text}</QText>
      </View>
      <View style={styles.line} />
    </View>
  );
};

DividerText.propTypes = {
  text: PropTypes.string,
};

DividerText.defaultProps = {
  text: '',
};
const styles = StyleSheet.create({
  dividerContainer: {
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    marginVertical: 15,
  },
  line: {
    flex: 1,
    height: 1,
    backgroundColor: '#BAC0CE',
  },
  text: {
    textAlign: 'center',
    paddingHorizontal: 8,
  },
});

export default memo(DividerText);
